<swal
  #swal
  icon="warning"
  (confirm)="confirm.emit()"
  [stopKeydownPropagation]="false"
  confirmButtonColor="#3085d6"
  cancelButtonColor="#d33"
  [showCancelButton]="true"
>
  <ng-container *swalPortal="swalTargets.title">
    <span [translationEditableDirective]="titleTrnKey">{{
      titleTrnKey | translate : { defaultValue: title }
    }}</span>
  </ng-container>

  <ng-container *swalPortal="swalTargets.content">
    <span [translationEditableDirective]="textTrnKey">{{
      textTrnKey | translate : { defaultValue: text }
    }}</span>
  </ng-container>

  <ng-container *swalPortal="swalTargets.cancelButton">
    <span translationEditableDirective="CANCEL">{{
      'CANCEL' | translate
    }}</span>
  </ng-container>

  <ng-container *swalPortal="swalTargets.confirmButton">
    <span translationEditableDirective="YES_DO_IT">{{
      'YES_DO_IT' | translate
    }}</span>
  </ng-container>
</swal>
